import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Language } from '../data/translations';
const OPTIONS: {
  value: Language;
  label: string;
}[] = [{
  value: 'id',
  label: 'ID'
}, {
  value: 'en',
  label: 'EN'
}];
export function LanguageToggle({
  className = ''
}: {
  className?: string;
}) {
  const {
    language,
    setLanguage
  } = useLanguage();
  return <div role="group" aria-label="Language / Bahasa" className={`inline-flex items-center rounded-full border border-slate-200 bg-slate-50 p-1 ${className}`} data-id="element-120" data-mp="2t5xhcqvkv9y8">
      {OPTIONS.map(option => {
      const active = language === option.value;
      return <button key={option.value} type="button" onClick={() => setLanguage(option.value)} aria-pressed={active} className={`rounded-full px-3 py-1.5 text-[13px] font-bold transition-colors ${active ? 'bg-blue-600 text-white shadow-sm' : 'text-slate-500 hover:text-slate-800'}`} data-id="element-121" data-mp="2fa28zeyt1h93">
            {option.label}
          </button>;
    })}
    </div>;
}